import AOS from 'aos';
import 'aos/dist/aos.css';
import Home from './pages/header/Home';
import Content from './pages/content/Content';
import Footer from './pages/footer/Footer';
import { Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import ContentVideo from './pages/content/ContentVideo';
import ErrorPage from './pages/error/ErrorPage';
import Preloader from './pages/loader/Preloader';
import { useEffect, useState } from 'react';
AOS.init();

function App() {
  const [loading, setLoading] = useState(true);
  const pathname = useLocation().pathname
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  useEffect(() => {
    const handlePageLoad = () => {
      setLoading(false);
    };

    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
      return () => window.removeEventListener("load", handlePageLoad);
    }
  }, []);
  return (
    <div className="App">
      {
        loading
          ?
          <Preloader />
          :
          <>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contents" element={<Content />} />
              <Route path="contents/:contentName" element={<ContentVideo />} />
              <Route path="*" element={<ErrorPage />} />
            </Routes>
            <Footer />
          </>
      }
    </div>
  );
}

export default App;
